import { render } from "./what-we-offer.vue?vue&type=template&id=afa01a3c&scoped=true"
import script from "./what-we-offer.vue?vue&type=script&lang=js"
export * from "./what-we-offer.vue?vue&type=script&lang=js"

import "./what-we-offer.vue?vue&type=style&index=0&id=afa01a3c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa01a3c"]])

export default __exports__